import router from './router'
import store from './store'
import {Message,MessageBox} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import {getToken, removeToken} from '@/utils/auth' // getToken from cookie

NProgress.configure({showSpinner: false})// NProgress Configuration

// permission judge function
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('admin') >= 0) return true // admin permission passed directly
  if (!permissionRoles) return true
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

const whiteList = ['/login', '/auth-redirect', '/forbidden']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  document.title = '管理中心';
  if (getToken() && to.path !== '/login') { // determine if there has token 
    // has token
    // 0200604 如果访问登录，不在转入首页*/
    if (to.path === '/login') {
      next({path: '/index'})
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      // 初始化环境，商品信息，菜单 
        if (store.getters.userRemoteMenuIds.length === 0) {
          store.dispatch('GetUserMenus').then(res => { //  
            store.dispatch('GetBrands');
            // 如果没有菜单权限，跳转到错误页面 
            if (store.getters.userRemoteMenuIds.length === 0) {
              next({path: '/forbidden'})
            } else {
              next()
            }
          }).catch((res) => {
           // Message.error(err)
          }) 
        } else {
          next()
        } 
    }
  } else {
    // has no token*
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js